import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import VueMarkdown from 'vue-markdown';
let VueMarkdownWithAnchors = class VueMarkdownWithAnchors extends Vue {
    jumpToHash() {
        this.$nextTick(() => {
            const element = document.getElementById(this.$route.hash.slice(1));
            if (element) {
                element.scrollIntoView();
                if (window.scrollY > 75)
                    window.scroll(0, window.scrollY - 75);
            }
        });
    }
};
__decorate([
    Prop(String)
], VueMarkdownWithAnchors.prototype, "source", void 0);
VueMarkdownWithAnchors = __decorate([
    Component({
        components: {
            VueMarkdown
        }
    })
], VueMarkdownWithAnchors);
export default VueMarkdownWithAnchors;
